export default __webpack_public_path__ + "static/media/payment-visa.964a6235.svg";